export default __webpack_public_path__ + "static/media/test-assignment-sante24-hero-fr.0742e08b.png";